export default __webpack_public_path__ + "static/media/CNo.79-2.e115e463.jpg";